<div class="main-content">
    <form [formGroup]="newOrderForm">
        <!--    ///////   TOP ACTION BUTTONS & ORDER STATUS SECTION    /////// -->
        <div class="order-top-buttons-container">

            <div class="order-top-buttons-sub-container">

                 <button (click)="openOrderBackDialog()" mat-button class="lab-manager-button back-button">
                        <mat-icon>arrow_back</mat-icon>
                        BACK
                </button>

                <!-- <button class="main-order-back-btn mdc-button mdc-button--outlined" type="button"
                    (click)="openOrderBackDialog()">
                    <div class="main-order-back-btn-content">
                        <img src="../../../../../assets/order-to-cash-icons/arrow-back.svg" alt="Back Icon"
                            class="main-order-back-btn-icon">
                        <span>
                            <p class="main-order-back-btn-text">BACK</p>
                        </span>
                    </div>
                </button> -->

                <button *ngIf="isDraft" class="order-delete-draft-btn" mat-flat-button type="button"
                    (click)="openRemoveOrderDialog()">
                    <div class="order-delete-draft-content">
                        <span>
                            <p class="order-delete-draft-btn-text">DELETE DRAFT</p>
                        </span>
                    </div>
                </button>

                <button *ngIf="isEditOrderOptionsEnabled" class="order-save-draft-btn" mat-flat-button
                    type="button" (click)="saveDraft()">
                    <div class="order-save-draft-btn-content">
                        <span>
                            <p class="order-save-draft-btn-text">{{saveUpdateBtn}}</p>
                        </span>
                    </div>
                </button>

                <!-- <button class="order-downloadPDF-btn" mat-flat-button type="button" (click)="downloadOrderReport()">
                    <div class="order-downloadPDF-btn-content">
                        <img src="../../../../../assets/order-to-cash-icons/download.svg" alt="Download Icon" class="order-downloadPDF-icon">
                        <span><p class="order-downloadPDF-text">DOWNLOAD PDF</p></span>
                    </div>
                </button> -->

                <div class="downloads-container" *ngIf="hideButtonOptions">
                    <mat-accordion class="order-downloads-btn">
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="order-downloads-btn-text">
                                    DOWNLOADS
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div (click)="downloadOrderReport()" class="download-container">
                                <div type="button" class="downloads-option-text-container">
                                    <p class="order-downloads-option-text">
                                        {{(orderObj?.orderStatus?.id === orderStatusTypeObj?.submittedToSapStatus || 
                                          orderObj?.orderStatus?.id === orderStatusTypeObj?.updatedSubmitedToSapStatus)  ? 'Order' : 'Quote'}} </p>
    
                                    <!-- <a href="mailto:?subject={{subject}}" (click)="mailtoPDF()">
                                        <img src="../../../../../assets/order-to-cash-icons/mail.svg" alt="Email Icon"
                                            class="order-downloadPDF-icon">
                                    </a> -->
    
                                    <img src="../../../../../assets/order-to-cash-icons/download.svg" alt="Download Icon" class="order-downloadPDF-icon">
                                </div>
                            </div>



                            <div (click)="downloadSocReport()" class="download-container">
                                <div type="button" class="downloads-option-text-container">
                                    <p [ngClass]="(orderObj?.orderStatus?.id === orderStatusTypeObj?.submittedToSapStatus || 
                                                orderObj?.orderStatus?.id === orderStatusTypeObj?.updatedSubmitedToSapStatus) && orderObj?.ysapOrderNumber ? 'order-downloads-option-text' : 'order-downloads-option-text-disabled'">
                                        SOC</p>
    
                                    <!-- <a href="mailto:?subject={{subject}}" (click)="mailtoSOC()">
                                        <img src="../../../../../assets/order-to-cash-icons/mail.svg" alt="Email Icon"
                                            class="order-downloadPDF-icon">
                                    </a> -->
    
                                    <img src="../../../../../assets/order-to-cash-icons/download.svg" alt="Download Icon" 
                                    [ngClass]="(orderObj?.orderStatus?.id === orderStatusTypeObj?.submittedToSapStatus || 
                                                orderObj?.orderStatus?.id === orderStatusTypeObj?.updatedSubmitedToSapStatus) && orderObj?.ysapOrderNumber ? 'order-downloadPDF-icon' : 'order-downloadPDF-icon-disabled'">
    
                                </div>
                            </div>


                        </mat-expansion-panel>
                    </mat-accordion>
                </div>


                <!-- <button mat-button [matMenuTriggerFor]="menu" class="order-downloads-btn" mat-flat-button type="button">
                    <div class="order-downloadPDF-btn-content">
                        <span><p class="order-downloadPDF-text">DOWNLOADS</p></span>
                    </div>
                   </button>

                 <mat-menu #menu="matMenu" id="order-downloads-menu ">
                    <button mat-menu-item type="button" (click)="downloadOrderReport()">PDF    <img src="../../../../../assets/order-to-cash-icons/download.svg" alt="Download Icon" class="order-downloadPDF-icon"></button>
                    <button mat-menu-item ><a class="mailto"  href="mailto:{{email}}"  style="text-decoration: none!important;color: black;">SOC <img src="../../../../../assets/order-to-cash-icons/download.svg" alt="Download Icon" class="order-downloadPDF-icon"></a></button>
                </mat-menu> -->

                <button *ngIf="isEditOrderOptionsEnabled && isOrderToSapBtnDisabled && hideButtonOptions" class="order-submit-SAP-btn"
                    mat-flat-button type="button" (click)="openSubmitToSapDialog()">
                    <div class="order-submit-SAP-btn-content">
                        <img src="../../../../../assets/order-to-cash-icons/save.svg" alt="Save Icon"
                            class="order-submit-SAP-btn-icon">
                        <span>
                            <p class="order-submit-SAP-btn-text">{{submitBtn}}</p>
                        </span>
                    </div>
                </button>


                <button *ngIf="isPendingApproval" class="order-approve-btn" mat-flat-button
                    type="button" (click)="openApproveConfirmDialog()">
                    <div class="order-approve-btn-content">
                        <span>
                            <p class="order-approve-btn-text">APPROVE</p>
                        </span>
                    </div>
                </button>


                <button *ngIf="isPendingApproval" class="order-reject-btn" mat-flat-button type="button"
                    (click)="openRejectConfirmDialog()">
                    <div class="order-reject-btn-content">
                        <span>
                            <p class="order-reject-btn-text">REJECT</p>
                        </span>
                    </div>
                </button>

                <button *ngIf="isRecallable" [disabled]="!isRecallEnabled" class="order-recall-btn" mat-flat-button type="button"
                    (click)="openRecallConfirmDialog()"
                    [matTooltip]="!isRecallEnabled ? 'You do not have permission to recall this order' : ''">
                    <div class="order-recall-btn-content">
                        <span>
                            <p class="order-recall-btn-text">RECALL</p>
                        </span>
                    </div>
                </button>

                <button *ngIf="isEditOrderEnabled" class="order-edit-btn" mat-flat-button type="button"
                    (click)="editSubmittedToSapOrder()">
                    <div class="order-edit-btn-content">
                        <span>
                            <p class="order-edit-btn-text">EDIT ORDER</p>
                        </span>
                    </div>
                </button>

            <button [ngClass]="isCopyOrderEnabled ? 'copy-order-btn' : 'disabled-copy-order-btn'"  mat-flat-button
                type="button" (click)="copyOrder()">
                <div class="order-save-draft-btn-content">
                    <span>
                        <p class="disabled-copy-order-btn-text">COPY ORDER</p>
                    </span>
                </div>
            </button>

                <div class="order-top-button-spacer">

                    <div *ngIf="isMobileNoticeVisible" class="mobile-notice-container mat-tooltip-panel-before" F>
                        <img src="../../../../../assets/order-to-cash-icons/is-mobile-icon.svg" alt="Is Mobole Icon"
                            class="is-mobile-notice-icon">
                    </div>


                    <!-- <div class="approval-note-status" *ngIf="isPendingApproval">
                        <p class="approval-note-text">Reason for Approval</p>
                        <div class="approval-note-current-status">
                            <p class="approval-note-status-text" *ngIf="showNotice">{{approvalMessageSplit[0]}} <span
                                    *ngIf="showNoticeSplitterOne"> <mat-divider [vertical]="true"
                                        style="width:1px; height:40px; background-color: white; margin-left: 6px; margin-right: 6px;"></mat-divider>
                                </span></p>
                            <br>
                            <p class="approval-note-status-text" *ngIf="showNotice">{{approvalMessageSplit[1]}} <span
                                    *ngIf="showNoticeSplitterTwo"> <mat-divider [vertical]="true"
                                        style="width:1px; height:40px; background-color: white; margin-left: 6px; margin-right: 6px;"></mat-divider>
                                </span></p>
                            <br>
                            <p class="approval-note-status-text" *ngIf="showNotice">{{approvalMessageSplit[2]}} </p>
                        </div>
                    </div> -->

                    <button style="width: 80px; margin-right: 10px;" mat-icon-button (click)="isHistoryPanelOpen = !isHistoryPanelOpen" matTooltip="Order History">
                        <mat-icon>history</mat-icon>
                    </button>


                <div class="approval-note-status" *ngIf="isPendingApproval">
                        <p class="approval-note-text">Reason for Approval</p>
                        <div class="approval-note-current-status">
                            <p class="approval-note-status-text" *ngIf="showNotice">{{approvalMessageSplit[0]}} <span
                                    *ngIf="showNoticeSplitterOne"> <mat-divider [vertical]="true"
                                        style="width:1px; height:40px; background-color: white; margin-left: 6px; margin-right: 6px;"></mat-divider>
                                </span></p>
                            <br>
                            <p class="approval-note-status-text" *ngIf="showNotice">{{approvalMessageSplit[1]}} <span
                                    *ngIf="showNoticeSplitterTwo"> <mat-divider [vertical]="true"
                                        style="width:1px; height:40px; background-color: white; margin-left: 6px; margin-right: 6px;"></mat-divider>
                                </span></p>
                            <br>
                            <p class="approval-note-status-text" *ngIf="showNotice">{{approvalMessageSplit[2]}} </p>
                        </div>
                    </div>


                    <div class="order-status">
                        <p class="order-status-text">Order Status</p>
                        <div class="order-current-status">
                            <p class="current-status-text">{{orderObj.orderStatus ? orderObj.orderStatus.description :
                                placeholder}}</p>

                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div class="scrollable-container">

            <!--    ///////   ORDER NUMBER & GENERAL  DETAILS SECTION    /////// -->

            <div class="order-orderID-container">
                <div class="order-id-container">
                    <p class="order-id-text">ORDER NO:</p> <span>
                        <p class="order-id-no">{{orderObj.displayOrderNumber ? orderObj.displayOrderNumber : placeholder}}</p>
                    </span>
                </div>
                <div class="order-id-date-container">
                    <p class="order-id-date-text">Order Date:</p> <span>
                        <p class="order-id-date-no">{{orderObj.orderDate ?
                            dayjs(orderObj.orderDate).format(dateStringFormatting) :
                            currentDate.format(dateStringFormatting)}}</p>
                    </span>
                </div>
            </div>


            <div class="order-general-details-container">
                <div class="general-details-container">
                    <p class="general-details-header-text section-headers">General Details</p>
                </div>
                <div class="general-details-info-container">
                    <p class="details-heading-text">Rep/Agent Name:</p>
                    <p class="details-text">{{orderObj.rep ? (orderObj.rep.user.name ? orderObj.rep.user.name :
                        placeholder) : placeholder}}
                        <span class="rep-surname-text">{{orderObj.rep? (orderObj.rep.user.surname ?
                            orderObj.rep.user.surname : placeholder) : placeholder}}</span>
                    </p>
                    <!-- <span class="gen-detail-splitter"> | </span>
                    <p class="details-heading-text">Agent Id:</p> <p class="details-text">{{orderObj.rep ? (orderObj.rep.id ? orderObj.rep.id : placeholder) : placeholder}}</p> -->
                    <span class="gen-detail-splitter"> | </span>
                    <p class="details-heading-text">Date Created:</p>
                    <p class="details-text">{{orderObj.dateCreated ?
                        dayjs(orderObj.dateCreated).format(dateStringFormatting) : placeholder}}</p>
                    <span class="gen-detail-splitter"> | </span>
                    <p class="details-heading-text">Date Submitted to SAP:</p>
                    <p class="details-text">{{orderObj.ysapOrderCreattionDate ?
                        dayjs(orderObj.ysapOrderCreattionDate).format(dateStringFormatting) : placeholder}}</p>
                    <!-- <span class="gen-detail-splitter"> | </span>
                    <p class="details-heading-text">Date Fulfilled:</p> <p class="details-text">{{placeholder}}</p> -->
                    <span class="gen-detail-splitter"> | </span>
                    <p class="details-heading-text">Total Tons:</p>
                    <p class="details-text">{{convertedTotalTons ? convertedTotalTons : placeholder}}</p>
                    <span class="gen-detail-splitter"> | </span>
                    <p class="details-heading-text">Price List:</p>
                    <p class="details-text">{{selectedSoldToCustomer ? selectedSoldToCustomer.priceListFriendlyName :
                        placeholder}}</p>
                </div>
            </div>

            <mat-divider></mat-divider>

            <!--    ///////   ORDER DETAILS SECTION    /////// -->
            <div>
                <section class="order-details-section">
                    <div class="order-details-container">
                        <p class="order-details-header-text section-headers">Order Details</p>
                    </div>

                    <div class="crop-kbpf-container">
                        <div class="crop-select-dropdown-container">
                            <div class="crop-select-dropdown">
                                <mat-form-field class="order-dropdown" appearance="outline">
                                    <mat-label class="custom-label" appRemoveAriaOwns>Select Crop</mat-label>
                                    <mat-select formControlName="cropId">
                                        <mat-option style="background-color: white!important; padding: 6px!important;">
                                            <div class="select-search-container-sm">
                                                <div class="select-search-sm">
                                                    <ngx-mat-select-search placeholderLabel="Search Crop" [formControl]="cropFilterCtrl">
                                                <span ngxMatSelectNoEntriesFound>
                                                    No entries found
                                                </span>
                                                    </ngx-mat-select-search>
                                                </div>
                                            </div>
                                        </mat-option>
                                        <mat-option *ngFor="let crop of filteredCropList" [value]="crop.id">
                                            {{crop.description}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="newOrderForm.get('cropId').invalid && newOrderForm.get('cropId').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Select a crop
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>


                        <div class="radio-kb-sapcode-container">
                            <div class="radio-container">
                                <div class="radio-group-container">

                                    <mat-radio-group [disabled]="!isEditOrderOptionsEnabled || orderObj?.ysapOrderNumber">
                                        <mat-radio-button [value]="isKb" (change)="kBCheck()" 
                                            [checked]="newOrderForm.controls['isKb'].value">KB</mat-radio-button>
                                        <span class="radio-splitter"> | </span>
                                        <mat-radio-button [value]="isPf" (change)="pFCheck()"
                                            [checked]="newOrderForm.controls['isPf'].value">PF</mat-radio-button>
                                    </mat-radio-group>
                                    <span class="radio-splitter"> | </span>
                                    <mat-checkbox class="example-margin" (click)="suffixSpecialCheck()" formControlName="suffixCheck">SP</mat-checkbox>
                                    </div>
                                <div>
                            </div>        
                        </div>

                            @if(isSuffixVisable){
                                <div class="suffix-dropdown-container">
                                    <mat-form-field class="order-dropdown input-space" appearance="outline">
                                    <mat-label class="custom-label" appRemoveAriaOwns>Select an option</mat-label>
                                    <mat-select formControlName="suffixId" #singleSelect>

                                @for (suffix of orderSuffixListList; track suffix){
                                    <mat-option [value]="suffix.id" (click)="setOrderSuffixCode(suffix)">
                                        {{suffix.suffixCode}} - {{suffix.description}}
                                      </mat-option>
                                }
               
                                    </mat-select>
                                    <mat-error
                                        *ngIf="newOrderForm.get('soldToId').invalid && newOrderForm.get('soldToId').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Select an option
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        }

                            <p class="details-heading-text order-details-text-min-width">KB/PF Number: </p>
                            <p class="details-text">{{orderObj.displayOrderNumber ? orderObj.displayOrderNumber : placeholder}}</p>
                            <span class="customer-splitter"> | </span>
                            <p class="details-heading-text order-details-text-min-width">SAP CODE: </p>
                            <p class="details-text">{{orderObj.ysapOrderNumber ? orderObj.ysapOrderNumber :
                                placeholder}}</p>
                        </div>
                    </div>

                </section>

            </div>

            <mat-divider></mat-divider>


            <!--    ///////   SOLD TO DETAILS SECTION    /////// -->
            <div class="sold-to-payer-details-container">
                <section class="sold-to-details-section">
                    <div class="sold-to-details-container">
                        <div class="sold-to-header-container">
                            <p class="sold-to-details-header-text section-headers">Sold-To Details</p>
                        </div>

                        <div class="sold-to-client-select-dropdown-container">
                            <div class="sold-to-dropdown-container">
                                <mat-form-field class="order-dropdown input-space" appearance="outline">
                                    <mat-label class="custom-label" appRemoveAriaOwns>Select Client</mat-label>
                                    <mat-select formControlName="soldToId" #singleSelect>
                                        <mat-option style="background-color: white!important; padding: 6px!important">
                                            <div class="select-search-container-max">
                                              <div class="select-search-max">
                                                <ngx-mat-select-search placeholderLabel="Search Client" [formControl]="soldToFilterCtrl">
                                                    <span ngxMatSelectNoEntriesFound>
                                                        No entries found
                                                    </span>
                                                </ngx-mat-select-search>
                                    </div>
                                </div>
                                      </mat-option>
                                
                                      <mat-option *ngFor="let customer of filteredSoldTos | async | orderBy: 'name'" [value]="customer.id" [disabled]="customer.isDeleted" (onSelectionChange)="$event.isUserInput && setSelectedSoldTo(customer)">
                                        {{customer.ysapCode}} - {{customer.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="newOrderForm.get('soldToId').invalid && newOrderForm.get('soldToId').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Select a sold to
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <!-- <div class="radius-container">
                                <mat-form-field class="radius-input input-space" appearance="outline">
                                    <mat-label class="custom-label">Radius</mat-label>
                                    <input nxNoScroll matInput formControlName="radius" (focusout)="checkRadiusValue()"
                                        type="number">
                                    <mat-error
                                        *ngIf="newOrderForm.get('radius').invalid && newOrderForm.get('radius').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Should be between 0 and
                                        70
                                    </mat-error>
                                </mat-form-field>
                            </div> -->
                        </div>


                        <div class="contact-inputs-container">

                            <div class="radius-container">
                                <mat-form-field class="radius-input input-space" appearance="outline">
                                    <mat-label class="custom-label">Radius</mat-label>
                                    <input nxNoScroll matInput formControlName="radius" (focusout)="checkRadiusValue()"
                                        type="number">
                                    <mat-error
                                        *ngIf="newOrderForm.get('radius').invalid && newOrderForm.get('radius').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Should be between 0 and
                                        70
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            
                            <div class="contact-person-container">
                                <mat-form-field class="order-input input-space" appearance="outline">
                                    <mat-label class="custom-label">Contact Person</mat-label>
                                    <input matInput matInput
                                        oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                                        formControlName="contactPerson">
                                    <mat-error
                                        *ngIf="newOrderForm.get('contactPerson').invalid && newOrderForm.get('contactPerson').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Enter a contact
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="contact-no-container">
                                <mat-form-field class="order-input input-space" appearance="outline">
                                    <mat-label class="custom-label">Contact Number</mat-label>
                                    <input matInput
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                        formControlName="contactNumber">
                                    <mat-error
                                        *ngIf="newOrderForm.get('contactNumber').invalid && newOrderForm.get('contactNumber').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Enter a contact no.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="sold-to-address-header-container">
                            <p class="sold-to-details-header-text section-headers" *ngIf="!isAltCustomerAddressChecked;
                                else altCustomerAddressSelected">Ship-To Address</p>
                            <ng-template #altCustomerAddressSelected>
                                <p class="sold-to-details-header-text section-headers">Alt-Ship-To Address</p>
                            </ng-template>

                        </div>
                        <div class="sold-to-address-container">
                            <div class="sold-to-address-headers">
                                <p class="sold-to-info-header-text">Address:</p>
                                <p class="sold-to-info-header-text">Town:</p>
                                <p class="sold-to-info-header-text">Code:</p>

                            </div>


                            <!--                           ////// SOLD TO DETAILS  //////      -->
                            <div class="sold-to-address-details">

                                <ng-container
                                    *ngIf="selectedSoldToCustomer && isCustomerSelected && !isAltCustomerAddressChecked">
                                    <p class="sold-to-info-text">{{selectedSoldToCustomer?.address?.addressLine1 ||
                                        selectedSoldToCustomer?.address?.addressLine2 ||
                                        selectedSoldToCustomer?.address?.addressLine3 ?
                                        ((selectedSoldToCustomer?.address?.addressLine1 === null ? '' :
                                        selectedSoldToCustomer?.address?.addressLine1) +
                                        ' ' + (selectedSoldToCustomer?.address?.addressLine2 === null ? '' :
                                        selectedSoldToCustomer?.address?.addressLine2) +
                                        ' ' + (selectedSoldToCustomer?.address?.addressLine3 == null ? '' :
                                        selectedSoldToCustomer?.address?.addressLine3)) : placeholder}}</p>

                                    <p class="sold-to-info-text">{{selectedSoldToCustomer.address.town ? selectedSoldToCustomer.address.town : placeholder}}
                                    </p>
                                    <p class="sold-to-info-text">{{selectedSoldToCustomer.address.postalCode ? selectedSoldToCustomer.address.postalCode : placeholder}}</p>
                                </ng-container>


                                <!--            ////// ALT SOLD TO DETAILS  //////      -->

                                <ng-container
                                    *ngIf="selectedSoldToCustomer && isCustomerSelected && isAltCustomerAddressSelected && isAltCustomerAddressChecked">
                                    <ng-container>
                                        <p class="sold-to-info-text">{{altAddress.addressLine1 ||
                                            altAddress.addressLine2 || altAddress.addressLine3 ?
                                            ((altAddress.addressLine1 === null ? '' : altAddress.addressLine1) +
                                            ' ' + (altAddress.addressLine2 === null ? '' : altAddress.addressLine2) +
                                            ' ' + (altAddress.addressLine3 === null ? '' : altAddress.addressLine3)) :
                                            placeholder }}</p>
                                        <p class="sold-to-info-text">{{altAddress.town ? altAddress.town : placeholder }}</p>
                                        <p class="sold-to-info-text">{{altAddress.postalCode ? altAddress.postalCode : placeholder }}</p>
                                    </ng-container>
                                </ng-container>


                            </div>


                        </div>
                        <div class="ship-to-alt-container">
                            <mat-checkbox class="ship-to-alt-checkbox" formControlName="isAltAddress"
                                (change)="altAddressChecked()">Ship to a different address?</mat-checkbox>
                        </div>

                        <div class="add-alt-btn-container">
                            <div class="sold-to-dropdown-container">
                                <mat-form-field class="order-dropdown" appearance="outline">
                                    <mat-label class="custom-label" appRemoveAriaOwns>Selected Alt. Address</mat-label>
                                    <mat-select formControlName="deliveryAddressId" #singleSelect style="min-width: 200px;">
                                        <mat-option style="background-color: white!important; padding: 6px!important">
                                            <div class="select-search-container-max">
                                                <div class="select-search-max">
                                                    <ngx-mat-select-search placeholderLabel="Search Alt Addresses"
                                                        [formControl]="altAddressFilterCtrl">
                                                        <span ngxMatSelectNoEntriesFound>
                                                            No entries found
                                                        </span>
                                                    </ngx-mat-select-search>
                                                </div>
                                            </div>
                                        </mat-option>

                                        <mat-option
                                            *ngFor="let altDetail of filteredAltAddresses | async | orderBy: 'addressLine1'"
                                            [value]="altDetail.id" (click)="setSelectedAltAddress(altDetail)">
                                            {{(altDetail.addressLine1 === null ? '' : altDetail.addressLine1)
                                            + ' ' + (altDetail.addressLine2 === null ? '' : altDetail.addressLine2)
                                            + ' ' + (altDetail.addressLine3 === null ? '' : altDetail.addressLine3)
                                            + ' ' + altDetail.town
                                            + ' ' + altDetail.province
                                            + ' ' + altDetail.postalCode}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </div>

                            <div class="order-add-alt-button-container">
                                <button *ngIf="isEditOrderOptionsEnabled" [disabled]="!isAltCustomerAddressChecked"
                                    class="order-add-alt-btn" mat-flat-button type="button"
                                    (click)="openEditAltAddressDialog()">
                                    <div class="order-add-alt-btn-content">
                                        <img src="../../../../../assets/order-to-cash-icons/add_icon.svg" alt="Add Icon"
                                            class="add-alt-btn-icon">
                                        <span>
                                            <p class="order-add-alt-btn-text">ADD ALT.ADDRESS</p>
                                        </span>
                                    </div>
                                </button>
                            </div>


                        </div>

                    </div>

                    <mat-divider [vertical]="true"></mat-divider>


                    <!--    ///////   PAYER DETAILS SECTION    /////// -->

                    <div class="payer-details-container">
                        <div class="payer-header-container">
                            <p class="payer-details-header-text section-headers">Payer Details</p>
                        </div>

                        <div class="payer-client-select-container">
                            <div class="payer-dropdown-container">
                                <mat-form-field class="order-dropdown input-space" appearance="outline">
                                    <mat-label class="custom-label" appRemoveAriaOwns>Select Payer</mat-label>
                                    <mat-select formControlName="payerId" #singleSelect>
                                        <mat-option style="background-color: white!important; padding: 6px!important">
                                            <div class="select-search-container-max">
                                              <div class="select-search-max">
                                        <ngx-mat-select-search placeholderLabel="Search Payer" [formControl]="payerFilterCtrl" style="width: 600px;" id="payer-search" (keydown.enter)="onPayerKeydown(null,$event)">
                                            <span ngxMatSelectNoEntriesFound>
                                                No entries found
                                            </span>
                                        </ngx-mat-select-search>
                                    </div>
                                </div>
                                      </mat-option>
                                
                                      <mat-option *ngFor="let customer of filteredPayers | async | orderBy: 'name'" [value]="customer.id" [disabled]="customer.isDeleted" (click)="setSelectedPayer(customer, $event, null)" (onSelectionChange)="customerChangeDetect(customer, $event)">
                                        {{customer.ysapCode}} - {{customer.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="newOrderForm.get('payerId').invalid && newOrderForm.get('payerId').touched"
                                        class="error-notice">
                                        <strong class="item-required-text">Required* - </strong> Select a payer
                                    </mat-error>
                                </mat-form-field>
                            </div>


                        </div>

                        <div class="direct-payer-alt-container">
                            <mat-checkbox class="direct-payer-checkbox" (change)="directPayerChecked($event)"
                                formControlName="isDirectPayer">Direct Payer</mat-checkbox>
                        </div>

                        <div class="payer-address-header-container">
                            <p class="payer-details-header-text section-headers">Payer Address</p>
                        </div>
                        <div class="payer-address-container">
                            <div class="payer-address-headers">
                                <p class="payer-info-header-text ">Address:</p>
                                <p class="payer-info-header-text ">Town:</p>
                                <p class="payer-info-header-text ">Code:</p>
                                <p class="payer-info-header-text vat-reg-text">VAT Reg No:</p>
                            </div>


                            <div class="payer-address-details">
                                <ng-container
                                    *ngIf="selectedSoldToCustomer && isCustomerSelected && isDirectPayerSelected">
                                    <p class="sold-to-info-text">{{selectedSoldToCustomer?.address?.addressLine1 ||
                                        selectedSoldToCustomer?.address?.addressLine2 ||
                                        selectedSoldToCustomer?.address?.addressLine3 ?
                                        ((selectedSoldToCustomer?.address?.addressLine1 === null ? '' :
                                        selectedSoldToCustomer?.address?.addressLine1) +
                                        ' ' + (selectedSoldToCustomer?.address?.addressLine2 === null ? '' :
                                        selectedSoldToCustomer?.address?.addressLine2) +
                                        ' ' + (selectedSoldToCustomer?.address?.addressLine3 === null ? '' :
                                        selectedSoldToCustomer?.address?.addressLine3)) : placeholder}}</p>

                                    <p class="sold-to-info-text">{{selectedSoldToCustomer.address.town ? selectedSoldToCustomer.address.town : placeholder}}
                                    </p>
                                    <p class="sold-to-info-text">{{selectedSoldToCustomer.address.postalCode ? selectedSoldToCustomer.address.postalCode : placeholder}}</p>
                                    <p class="sold-to-info-text vat-reg-text">{{selectedSoldToCustomer.vatNumber ? selectedSoldToCustomer.vatNumber : placeholder}}</p>
                                </ng-container>

                                <ng-container *ngIf="selectedPayerCustomer && !isDirectPayerSelected">
                                    <p class="sold-to-info-text">{{selectedPayerCustomer.address.addressLine1 ||
                                        selectedPayerCustomer.address.addressLine2 ||
                                        selectedPayerCustomer.address.addressLine3 ?
                                        ((selectedPayerCustomer.address.addressLine1) +
                                        ' ' + (selectedPayerCustomer.address.addressLine2) +
                                        ' ' + (selectedPayerCustomer.address.addressLine3)) : placeholder}}</p>

                                    <p class="sold-to-info-text">{{selectedPayerCustomer.address.town ? selectedPayerCustomer.address.town : placeholder}}
                                    </p>
                                    <p class="sold-to-info-text">{{selectedPayerCustomer.address.postalCode ? selectedPayerCustomer.address.postalCode : placeholder}}</p>
                                    <p class="sold-to-info-text vat-reg-text">{{selectedPayerCustomer.vatNumber ? selectedPayerCustomer.vatNumber : placeholder}}</p>
                                </ng-container>

                            </div>
                        </div>

                        <div class="co-op-details-container">
                            <div class="co-op-inputs-container">
                                <div class="co-op-person-container">
                                    <mat-form-field class="order-input" appearance="outline">
                                        <mat-label class="custom-label">Customer Order No</mat-label>
                                        <input matInput
                                         oninput="if (this.value.length > 35) this.value = this.value.slice(0, 35);" 
                                        formControlName="customerOrderNumber">
                                    </mat-form-field>
                                </div>

                                <div class="co-op-person-container">
                                    <!--used for spacing-->
                                </div>
                            </div>


                            <div class="co-op-inputs-container">
                                <div class="co-op-person-container">
                                    <mat-form-field *ngIf="this.isPayerCoop" class="order-input" appearance="outline">
                                        <mat-label class="custom-label">Co-Op Order No.</mat-label>
                                        <input matInput formControlName="coopOrderNumber">
                                        <mat-error *ngIf="newOrderForm.get('coopOrderNumber').invalid && newOrderForm.get('coopOrderNumber').touched
                                        " class="error-notice">
                                            <strong class="item-required-text">Required* - </strong> Enter a Co Op
                                            number
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="co-op-inputs-container">
                                    <mat-form-field *ngIf="this.isPayerCoop" class="order-dropdown input-space"
                                        appearance="outline" style="min-width: 200px; margin-left: 10px;">
                                        <mat-label class="custom-label" appRemoveAriaOwns>Select a Co-Op Member
                                            No.</mat-label>
                                        <mat-select formControlName="memberNumberId" #singleSelect
                                            (click)="populateCoOpMemberListDropDown(selectedSoldToCustomer.tenant.id, selectedPayerCustomer.tenant.id)">
                                            <mat-option
                                                style="background-color: white!important; padding: 6px!important;">
                                                <div class="select-search-container-max">
                                                    <div class="select-search-max">
                                                        <ngx-mat-select-search placeholderLabel="Search Member Number"
                                                            [formControl]="memberNumberFilterCtrl">
                                                            <span ngxMatSelectNoEntriesFound>
                                                                No entries found
                                                            </span>
                                                        </ngx-mat-select-search>
                                                    </div>
                                                </div>
                                            </mat-option>

                                            <mat-option
                                                *ngFor="let member of filteredMemberNumbers | async | orderBy: 'memberNumber'"
                                                [value]="member.id">
                                                {{member.memberNumber}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="newOrderForm.get('memberNumberId').invalid && newOrderForm.get('memberNumberId').touched"
                                            class="error-notice">
                                            <strong class="item-required-text">Required* - </strong> Select a member
                                        </mat-error>
                                    </mat-form-field>

                                    <div *ngIf="this.isPayerCoop" class="add-co-op-item-btn-container">
                                        <button *ngIf="isEditOrderOptionsEnabled" class="add-co-op-item-btn"
                                            mat-flat-button type="button" (click)="openAddCoOpDialog()">
                                            <div class="add-co-op-content">
                                                <img style="color: white;" src="../../../../../assets/order-to-cash-icons/add_icon.svg"
                                                    alt="Add Icon" class="add-co-op-icon">
                                            </div>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div class="section-spacer"></div>

            <mat-divider></mat-divider>


            <!--    ///////   PAYMENT DETAILS SECTION    /////// -->
            <div>
                <section class="payment-details-section">

                    <div class="term-date-picker-container">
                        <div class="term-select-dropdown">
                            <mat-form-field class="order-dropdown" appearance="outline">
                                <mat-label class="custom-label" appRemoveAriaOwns>Select Term</mat-label>
                                <mat-select class="order-dropdown-2" formControlName="paymentTermsId"
                                    (selectionChange)="setSelectedTerm($event.value)">
                                    <mat-option *ngFor="let term of availableTermList" [value]="term.id">
                                        {{term.description}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="newOrderForm.get('paymentTermsId').invalid && newOrderForm.get('paymentTermsId').touched"
                                    class="error-notice">
                                    <strong class="item-required-text">Required* - </strong> Select a term
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="payment-datepicker" *ngIf="pFChecked  || isPaymentDateVisable">
                            <mat-form-field class="order-input" appearance="outline">
                                <mat-label class="custom-label">Payment Date</mat-label>
                                <input matInput [matDatepicker]="picker1" [min]="minFixedPaymentDate" formControlName="fixedPaymentDate">
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                                <mat-error
                                    *ngIf="newOrderForm.get('fixedPaymentDate').hasError('matDatepickerMin')"
                                    class="error-notice">
                                    Payment date cannot be before the order date
                                </mat-error>
                                <mat-error
                                    *ngIf="newOrderForm.get('fixedPaymentDate').hasError('required') && newOrderForm.get('fixedPaymentDate').touched"
                                    class="error-notice">
                                    <strong class="item-required-text">Required* - </strong> Select a date
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="order-datepicker">
                            <mat-form-field class="order-input" appearance="outline">
                                <mat-label class="custom-label">Order Date</mat-label>
                                <input matInput [matDatepicker]="picker2" formControlName="orderDate" [max]="maxDate" >
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                                <mat-error
                                    *ngIf="newOrderForm.get('orderDate').invalid && newOrderForm.get('orderDate').touched"
                                    class="error-notice">
                                    <strong class="item-required-text">Required* - </strong> Select a date
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="valid-datepicker">
                            <mat-form-field class="order-input" appearance="outline">
                                <mat-label class="custom-label">Valid To Date</mat-label>
                                <input matInput [matDatepicker]="picker3" formControlName="validToDate">
                                <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                                <mat-datepicker #picker3></mat-datepicker>
                                <mat-error
                                    *ngIf="newOrderForm.get('validToDate').invalid && newOrderForm.get('validToDate').touched"
                                    class="error-notice">
                                    <strong class="item-required-text">Required* - </strong> Select a date
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </section>
            </div>

            <mat-divider></mat-divider>

            <div class="cost-bd-btn-container">
                <button *ngIf="isEditOrderOptionsEnabled" class="clear-items-cost-bd-btn" mat-flat-button
                    type="button" (click)=" openClearItemsAlertDialog()">
                    <div class="clear-items-cost-bd-btn-content">
                        <span>
                            <p class="add-order-note-btn-text">CLEAR ITEMS ONLY</p>
                        </span>
                    </div>
                </button>
                <button *ngIf="isEditOrderOptionsEnabled" [disabled]="!isAddItemEnabled" class="add-items-cost-bd-btn"
                    mat-flat-button type="button" (click)=" openAddItemDialog()">
                    <div class="add-items-cost-bd-btn-content">
                        <img src="../../../../../assets/order-to-cash-icons/add_icon.svg" alt="Add Icon"
                            class="add-items-cost-bd-icon">
                        <span>
                            <p class="add-items-cost-bd-btn-text">ADD ITEM</p>
                        </span>
                    </div>
                </button>
            </div>


            <!--    /////// TABLE  SECTION    /////// -->
            <div class="order-table-main-container">

                <section class="order-table-section">

                    <table mat-table matSort [dataSource]="dataSource.data" class="order-table" matSortDirection="asc">
                            <!-- Line item ACTIONS -->
                             
                          <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="order-top-left-cell"> Actions </th>
                            <td mat-cell *matCellDef="let element" class="item-action-btn-container">
                                 <!-- Edit Line item -->
                            <div class="item-btn-container">
                                    <button [disabled]="!isEditOrderOptionsEnabled" mat-icon-button
                                       (click)="openEditItemDialog(element)" [ngClass]="{'item-edit-btn' : isEditOrderOptionsEnabled, 'item-disabled-btn' : !isEditOrderOptionsEnabled }">
                                        <img src="../../../../../assets/order-to-cash-icons/edit.svg" alt="Edit Icon"
                                            class="item-edit-icon">
                                    </button>
                                </div>
                        <!-- Delete Line item -->
                                     <div class="item-btn-container">
                                    <button [disabled]="!isEditOrderOptionsEnabled"  mat-icon-button 
                                         (click)="openDeleteItemDialog(element)" [ngClass]="{'item-delete-btn' : isEditOrderOptionsEnabled, 'item-disabled-btn' : !isEditOrderOptionsEnabled }">
                            <img src="../../../../../assets/order-to-cash-icons/delete.svg"
                                            alt="Delete Icon" class="item-delete-icon">
                                    </button>
                                </div> 

                            </td> 

                        <!-- Order Id Column -->
                        <ng-container matColumnDef="plant">
                            <th mat-header-cell *matHeaderCellDef class="left-align mid-cell"> PLANT </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell"
                                style="text-align: left!important;">
                                <span
                                    *ngIf="element?.materialPricing?.plant?.name">{{element.materialPricing.plant.name}}</span>
                            </td>

                        </ng-container>

                        <!-- Order No Column -->
                        <ng-container matColumnDef="material">
                            <th mat-header-cell *matHeaderCellDef class="left-align mid-cell"> PRODUCT DESCRIPTION </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell"
                                style="text-align: left!important;">
                                <span
                                    *ngIf="element?.materialPricing?.material?.description">{{element.materialPricing.material.description}}</span>
                            </td>
                        </ng-container>

                        <!-- Order Date Column -->
                        <ng-container matColumnDef="qty">
                            <th mat-header-cell *matHeaderCellDef class="mid-cell"> Qty </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell"> {{element.qty}} </td>
                        </ng-container>

                        <!-- Client Column -->
                        <ng-container matColumnDef="unitOfMeasure">
                            <th mat-header-cell *matHeaderCellDef class="mid-cell"> UoM </th>
                            <td mat-cell *matCellDef="let element" class="mid-cell">
                                <span
                                    *ngIf="element?.materialPricing?.unitOfMeasure?.description">{{element.materialPricing.unitOfMeasure.description}}</span>
                            </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="delDate">
                            <th mat-header-cell *matHeaderCellDef class="mid-cell"> Del.Date </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">
                                <span *ngIf="element?.firstDeliveryDate"> {{element.firstDeliveryDate ?
                                    dayjs(element.firstDeliveryDate).format(dateStingFormattingSAP) :
                                    placeholder}}</span>
                            </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="ownTransport">
                            <th mat-header-cell *matHeaderCellDef class="mid-cell">Tpt Type</th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">
                                <div class="order-item-status-icon">
                                    <span *ngIf="element.ownTransport == false; else isOwnTransportSelected">Delivery</span>
                                </div>
                                <ng-template #isOwnTransportSelected>
                                     <span>Collection</span>
                                </ng-template>
                            </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="listPrice">
                            <th mat-header-cell *matHeaderCellDef class="mid-cell"> List Price </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">
                                <span *ngIf="element?.listPrice">{{element.listPrice ? (element.listPrice !== 0 ?
                                    (element.listPrice | currency:'R':'symbol':'1.0-2') : placeholder) :
                                    placeholder}}</span>
                            </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="totalPrice">
                            <th mat-header-cell *matHeaderCellDef class="mid-cell"> NETT Price</th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">
                                <span *ngIf="element?.listPrice">{{element.listPrice + (element.positivePriceAdjustment
                                    + element.negativePriceAdjustment) ?
                                    (element.listPrice + (element.positivePriceAdjustment +
                                    element.negativePriceAdjustment) !== 0 ?
                                    ( element.listPrice + (element.positivePriceAdjustment +
                                    element.negativePriceAdjustment) | currency:'R':'symbol':'1.0-2') : placeholder) :
                                    placeholder}}</span>

                            </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="specialDiscountPercentage">
                            <th mat-header-cell *matHeaderCellDef  class="mid-cell"> Special Disc % </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">
                                {{element.specialDiscountPercentage ? (element.specialDiscountPercentage !== 0 ?
                                (element.specialDiscountPercentage / 100 | percent:'1.0-3') : placeholder) :
                                placeholder}} </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="tradeDiscountPercentage">
                            <th mat-header-cell *matHeaderCellDef  class="mid-cell"> Trade Disc % </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">
                                {{element.tradeDiscountPercentage ? (element.tradeDiscountPercentage !== 0 ?
                                (element.tradeDiscountPercentage / 100 | percent:'1.0-3') : placeholder) : placeholder}}
                            </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="transportExpense">
                            <th mat-header-cell *matHeaderCellDef  class="mid-cell"> Transport R/Ton </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">{{element.transportExpense ?
                                (element.transportExpense !== 0 ? (element.transportExpense |
                                currency:'R':'symbol':'1.0-2') : placeholder) : placeholder}} </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="handlingCharge">
                            <th mat-header-cell *matHeaderCellDef  class="mid-cell"> Handeling R/Ton </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">{{element.handlingCharge ?
                                (element.handlingCharge !== 0 ? (element.handlingCharge | currency:'R':'symbol':'1.0-2')
                                : placeholder) : placeholder}} </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="netValueRUnit">
                            <th mat-header-cell *matHeaderCellDef  class="mid-cell"> NET Value R/Unit </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text mid-cell">{{element.totalPrice ?
                                ((element.totalPrice) / (element.qty) !== 0 ? ((element.totalPrice) / (element.qty) |
                                currency:'R':'symbol':'1.0-2') : placeholder) : placeholder}} </td>
                        </ng-container>

                        <!-- Order Val Column -->
                        <ng-container matColumnDef="totalExclVat">
                            <th mat-header-cell *matHeaderCellDef class="top-right-cell"> Total excl. VAT </th>
                            <td mat-cell *matCellDef="let element" class="order-table-text top-right-cell">{{element.totalPrice ?
                                (element.totalPrice !== 0 ? (element.totalPrice | currency:'R':'symbol':'1.0-2') :
                                placeholder) : placeholder}}
                        </ng-container>

                     </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </section>
            </div>

            <!--    ///////   ADD ITEM SUMMARY SECTION    /////// -->
            <div class="product-and-cost-summary-section-main-container">
                <section class="product-and-cost-summary-section">
                    <div class="product-sumarry-list-container">
                        <div class="product-sumarry-header-container">
                            <div class="product-summary-header">
                                <p class="text">Product SAP Code</p>
                            </div>
                            <div class="product-name-summary-header">
                                <p class="text">Product Description</p>
                            </div>
                            <div class="disc-level-summary-header">
                                <p class="text">In Discount Level</p>
                            </div>
                            <div class="total-disc-summary-header">
                                <p class="text">Total discount %</p>
                            </div>
                        </div>
                        <div class="product-sumarry-list-details-container">
                            <div class="product-sumarry-content-layout-container">
                                <div class="product-sumarry-content-container"
                                    *ngFor="let validationItem of discountValidationItems">
                                    <div class="product-summary-text">
                                        <p class="text">{{validationItem ? validationItem.sapCode: placeholder }}</p>
                                    </div>
                                    <div class="product-name-summary-text">
                                        <p class="text">{{validationItem ? validationItem.productName: placeholder }}
                                        </p>
                                    </div>
                                    <div class="disc-level-summary-status">
                                        <img *ngIf="!validationItem.inDiscountLevel; else isInDiscountLevel"
                                            src="../../../../../assets/order-to-cash-icons/close-icon.svg"
                                            alt="close Icon" class="disc-level-summary-status-icon">
                                    </div>
                                    <ng-template #isInDiscountLevel>
                                        <img src="../../../../../assets/order-to-cash-icons/check-mark.svg"
                                            alt="check mark Icon" class="disc-level-summary-status-icon">
                                    </ng-template>
                                    <div class="total-disc-summary-precentage"
                                        [ngClass]="validationItem.inDiscountLevel ? 'total-disc-summary-precentage' : 'total-disc-summary-precentage-red'">
                                        <p class="text">{{validationItem.totalDiscount}}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!--    ///////   ADD ITEM COST BREAKDOWN SECTION    /////// -->
                    <div class="cost-breakdown-container">
                        <div class="cost-breakdown-list-details-container">

                            <div class="cost-bd-gross-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Gross:</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.gross.toString() !== '0.00' ?
                                        orderTotals.gross : placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-spec-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Spec. Discount(-):</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.specDisc.toString() !== '(0.00)' ?
                                        orderTotals.specDisc : placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-trade-discount-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Trade Discount(-):</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.tradeDisc.toString() !== '(0.00)' ?
                                        orderTotals.tradeDisc : placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-sub-total-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Sub-Total:</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.subTotal1.toString() !== '0.00' ?
                                        orderTotals.subTotal1 : placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-trnsport-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Transport(+):</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.transport.toString() !== '0.00' ?
                                        orderTotals.transport : placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-handling-storage-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Handeling Storage (+):</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.handlingStorage.toString() !== '0.00' ?
                                        orderTotals.handlingStorage: placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-sub-total-secondary-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">Sub-Total:</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.subTotal2.toString() !== '0.00' ?
                                        orderTotals.subTotal2: placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-vat-surcharge-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">VAT on Surchargees (+):{{vatPercentage}}%</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.vatSurcharge.toString() !== '0.00' ?
                                        orderTotals.vatSurcharge : placeholder) : placeholder}}</p>
                                </div>
                            </div>

                            <div class="cost-bd-vat-container cost-bd-item-layout">
                                <div class="cost-bd-item-header-container"><p class="text">VAT(+):{{orderObj?.payer ? (orderObj?.payer?.taxCl ? vatPercentage : 0) : 0}}%</p></div>
                                <div class="cost-bd-item-currency-container"><p class="text">R</p></div>
                                <div class="cost-bd-item-container"><p class="text">{{orderTotals ? (orderTotals.vat.toString() !== '0.00' ? orderTotals.vat : placeholder) : placeholder}}</p></div>
                            </div>

                            <div class="cost-bd-total-container cost-bd-item-layout-total">
                                <div class="cost-bd-item-header-container">
                                    <p class="text">TOTAL</p>
                                </div>
                                <div class="cost-bd-item-currency-container">
                                    <p class="text">R</p>
                                </div>
                                <div class="cost-bd-item-container">
                                    <p class="text">{{orderTotals ? (orderTotals.total.toString() !== '0.00' ?
                                        orderTotals.total : placeholder) : placeholder}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <mat-divider></mat-divider>

            <!--    ///////   ORDER NOTES SECTION    /////// -->
            <div class="order-notes-main-container">
                <section class="order-notes-section">
                    <div class="order-notes-header-container">
                        <p class="order-notes-header-text section-headers">Order Notes</p>
                    </div>
                    <div class="order-note-input-container">
                        <div class="road-load-description-container">
                            <div>
                                <p class="road-load-notes-sub-heading">Road Description / Loading Instructions</p>
                            </div>
                            <textarea formControlName="loadingNotes" class="order-note-text-aria" name="load-note"
                                rows="4" cols="50" wrap="soft"></textarea>
                        </div>

                        <div class="additional-notes-container">
                            <div>
                                <p class="additional-notes-sub-heading">Additional Comments to CSC</p>
                            </div>
                            <textarea formControlName="additionalComments" class="order-note-text-aria" name="note"
                                rows="4" cols="50" wrap="soft"></textarea>
                        </div>
                    </div>
                </section>
            </div>
            <mat-divider></mat-divider>

            <!--    ///////   ADD ORDER LIST OF NOTES SECTION   /////// -->
            <div class="order-notes-main-container">
                <section class="order-notes-section">
                    <div class="order-notes-header-container">
                        <p class="order-notes-header-text section-headers">Order Notes</p>
                    </div>

                    <div class="add-order-note-btn-container">
                        <button class="add-order-note-btn" mat-flat-button type="button"
                            (click)=" openAddNoteDialog()">
                            <div class="add-order-note-btn-content">
                                <img src="../../../../../assets/order-to-cash-icons/add_icon.svg" alt="Add Icon"
                                    class="add-order-note-icon">
                                <span>
                                    <p class="add-order-note-btn-text">ADD NOTE</p>
                                </span>
                            </div>
                        </button>
                    </div>

                    <!--    ///////    NOTE ITEM  /////// -->
                    <div class="note-list-container">
                        <mat-card class="note-list-item-card" *ngFor="let noteItem of notes">
                            <div class="note-item-content-container">
                                <div class="note-item-text-container">
                                    <div class="note-item-created-date-text-container">
                                        <p class="note-item-bold-text">Created By:</p>
                                        <p class="note-item-details-text">{{noteItem.user.name}}</p>
                                        <span class="note-item-text-splitter"> | </span>
                                        <p class="details-heading-text">Date:</p>
                                        <p class="note-item-details-text">{{noteItem.dateModified ?
                                            dayjs(noteItem.dateModified).format(dateStringFormatting) : placeholder}}
                                        </p>
                                    </div>
                                    <p class="details-heading-text">Note:</p>
                                    <p class="note-item-details-text"></p>

                                    <div class="note-item-btn-container">

                                        <div class="delete-btn-container">
                                            <button class="note-delete-item-btn" matMiniFab
                                                type="button" (click)=" openDeleteNoteAlertDialog(noteItem)">
                                                <div class="note-delete-item-content">
                                                    <img src="../../../../../assets/order-to-cash-icons/delete.svg"
                                                        alt="Delete Icon" class="delete-note-icon">
                                                </div>
                                            </button>
                                        </div>

                                        <div class="edit-btn-container">
                                            <button class="note-edit-item-btn" matMiniFab
                                                type="button" (click)="openEditNoteAlertDialog(noteItem)">
                                                <div class="note-edit-item-content">
                                                    <img src="../../../../../assets/order-to-cash-icons/edit.svg"
                                                        alt="Edit Icon" class="edit-note-icon">
                                                </div>
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="note-item-description-text-container">
                                <p class="note-item-details-text">{{noteItem.note}}</p>
                            </div>
                        </mat-card>

                    </div>
                </section>
            </div>

            <mat-divider></mat-divider>

            <!--    ///////   ORDER ATTACHMENTS SECTION    /////// -->
            <div class="order-attachments-container">
                <section class="order-attachments-section">
                    <div class="order-attachments-header-container">
                        <p class="order-attachments-header-text section-headers">Order Attachments</p>
                    </div>


                    <div class="add-order-attachments-btn-container">
                        <button class="add-order-attachments-btn" mat-flat-button type="button"
                            (click)="openAddNewAttachmentDialog()">
                            <div class="add-order-attachments-btn-content">
                                <img src="../../../../../assets/order-to-cash-icons/attach.svg" alt="Attach Icon"
                                    class="add-order-attachments-icon">
                                <span>
                                    <p class="add-order-attachments-btn-text">ATTACH</p>
                                </span>
                            </div>
                        </button>
                    </div>

                    <!--    ///////    ATTACHMENT ITEM  /////// -->
                    <div class="order-attachments-list-container">
                        <mat-card class="order-attachments-item-card" *ngFor="let attachmentItem of attachments">
                            <div class="order-attachments-content-container">

                                <div class="order-attachments-text-container">
                                    <div class="order-attachments-created-date-text-container">
                                        <p class="order-attachments-item-bold-text">Created By:</p>
                                        <p class="order-attachments-details-text">{{attachmentItem.user ?
                                            attachmentItem.user.name : placeholder}}</p>
                                        <span class="order-attachments-item-text-splitter"> | </span>
                                        <p class="order-attachments-item-bold-text">Date Uploaded:</p>
                                        <p class="order-attachments-details-text">{{attachmentItem.dateModified ?
                                            dayjs(attachmentItem.dateModified).format(dateStringFormatting) :
                                            placeholder}}</p>
                                        <span class="order-attachments-item-text-splitter"> | </span>
                                        <p class="order-attachments-item-bold-text">Description:</p>
                                        <p class="order-attachments-details-text">{{attachmentItem.description}}</p>
                                    </div>
                                </div>
                                <div class="order-attachments-btn-container">

                                    <div class="delete-attachments-btn-container">
                                        <button class="order-attachments-delete-item-btn" matMiniFab 
                                            type="button"
                                            (click)="openRemoveAttachmentAlertDialog(attachmentItem)">
                                            <div class="order-attachments-delete-item-content">
                                                <img src="../../../../../assets/order-to-cash-icons/delete.svg"
                                                    alt="Delete Icon" class="delete-note-icon">
                                            </div>
                                        </button>
                                    </div>

                                    <div class="replace-attachments-btn-container">
                                        <button class="order-attachments-replace-item-btn" matMiniFab 
                                            type="button"
                                            (click)="openEditAttachmentDialog(attachmentItem)">
                                            <div class="order-attachments-replace-item-content">
                                                <img src="../../../../../assets/order-to-cash-icons/edit.svg"
                                                    alt="Edit Icon" class="replace-order-attachments-icon">
                                            </div>
                                        </button>
                                    </div>

                                    <div class="view-attachments-btn-container">
                                        <button class="view-attachments-item-btn" matMiniFab 
                                            type="button" (click)="downloadAttachment(attachmentItem)">
                                            <div class="view-attachments-item-content">
                                                <img src="../../../../../assets/order-to-cash-icons/download.svg"
                                                    alt="Download Icon" class="view-attachments-icon">
                                            </div>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </mat-card>

                    </div>

                </section>

                <router-outlet></router-outlet>

            </div>

        </div>

    </form>
</div>

<!-- Order History Side Panel -->
<div class="order-history-side-panel" *ngIf="isHistoryPanelOpen">
    <div class="order-history-side-panel-header">
        <h3>Order History</h3>
        <button mat-icon-button (click)="isHistoryPanelOpen = false">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <app-order-history [orderId]="orderObj?.id"></app-order-history>
</div>
<div class="order-history-overlay" *ngIf="isHistoryPanelOpen" (click)="isHistoryPanelOpen = false"></div>
